<app-data-table *ngIf="screenVisibility" [columns]="cols" [data]="notificationTemplates"  [url]="'/notification/templates/'" 
        [isDeletable]="'/master/notification-template' | hasPermission: 'Delete'" 
        [isView]="'/master/notification-template' | hasPermission: 'View'" 
        (viewEventRow)="viewNotificationTemplate($event)"
        [showAddButton]="'/master/notification-template' | hasPermission: 'Add'" 
        
        [isEditable]="'/master/notification-template' | hasPermission: 'Edit'" [title]="title" (onAdd)="addNotificationTemplate()"
        (editEventRow)="onUpdateNotificationTemplate($event)"  
        (deleteEventRow)="showDeleteNotificationTemplate($event)">
</app-data-table>

<!-- Reusable Dialog for Add/Edit/View -->
<app-reusable-dialog
    [(visible)]="showDialog"
    [config]="dialogConfig"
    [initialData]="formData"
    [viewMode]="viewMode"
    (onSubmit)="onSubmitNotificationTemplate($event)"
    (onCancel)="onCancelNotificationTemplate()"
    (onClose)="onCloseNotificationTemplate()">
</app-reusable-dialog>

<!-- Delete Confirmation Dialog -->
<p-dialog header="Delete Criteria" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog mt-3">
         <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete Criteria ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="onDeleteNotificationTemplate()">
        </p-button>
    </div>
</p-dialog>